
<div class="container-fluid h-100 bg-white p-5 pt-5" [busyIf]="isLoading" id="add-new-project-card">

    <div class="row ">
        <div class="col-lg-12 col-xl-8 border-right mb-lg-5 pb-lg-5">
            <form #projectForm="ngForm" id="projectForm" (ngSubmit)="save()" novalidate
                  autocomplete="off">
                <div class="row">
                    <div class="col-md-3 col-xl-2 text-center">
                        <div class=" border-left-red"></div>

                        <div class=" h-120px position-relative align-items-center text-center justify-content-center d-flex" *ngIf="showImg">
                            <div>
                                <img class="w-80px h-80px rounded" *ngIf="imagePath" [src]="imagePath" />
                                <img class="w-80px h-80px rounded" *ngIf="!imagePath"
                                     src="assets/common/images/header/defaultCompanyImage.svg" />
                            </div>
                        </div>
                        <div class="text-center">
                            <div *ngIf="!imagePath">
                                <label class="mb-2" data-toggle="modal" title=""
                                       data-original-title="Change avatar" a href=""
                                       (click)="isFormDisabled ? null : projectimgmodal.show()">
                                    <a class="blue cursor-pointer px-1"> {{ "UploadPhoto" | localize }} </a>
                                </label>
                            </div>
                             <div *ngIf="imagePath">
                                <label class="mb-2" (click)="isFormDisabled ? null : deletePicture()"
                                       data-toggle="tooltip" [style.display]="imagePath == '' ? 'none' : ''"
                                       title="">
                                    <a class="blue cursor-pointer px-1"> {{ "RemovePhoto" | localize }} </a>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-9 col-xl-10 pl-4">
                        <div class="form-group">
                            <label>{{ "ProjectName" | localize }}</label>
                            <span class="required text-danger ml-1">*</span>
                            <input type="text"
                                   class="form-control"
                                   #projectName="ngModel"
                                   [(ngModel)]="project.name"
                                   name="name"
                                   [ngClass]="{ 'is-invalid': projectForm.submitted && projectName.invalid ,'red-border':checkProjectDuplicate || isOnlySpaceInString}"
                                   placeholder="Enter Project Name"
                                   maxlength="70"
                                   (input)="NameVerify(project.name)"
                                   required
                                   autocomplete="off" />
                            <div *ngIf="projectForm.submitted">
                                <span *ngIf="projectName.invalid && projectName.errors.required" class="text-danger" id="error-message">
                                    {{ "Project name is mandatory" | localize }}
                                </span>
                            </div>
                            <div>
                                <span *ngIf="  !projectName.invalid && isOnlySpaceInString " class="text-danger" id="error-message">
                                    {{ "Project name is mandatory" | localize }}
                                </span>
                            </div>

                            <span *ngIf="checkProjectDuplicate" class="text-danger">
                                {{"Project name already exists"}}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-12 mt-5">
                        <div class="form-group">
                            <label>{{ "Description" | localize }}</label>
                            <textarea rows="3" class="form-control" name="description"
                                      [(ngModel)]="project.description" #ProjectDescription="ngModel"
                                      placeholder="Enter Description" autocomplete="off"></textarea>
                        </div>
                    </div>

                    <div class="col-md-12 mb-4 font-weight-bolder">Client Information</div>

                    <div class="col-md-12" id="projectClient" *ngIf="true">
                        <div class="form-group">
                            <label> {{ "Assign a Client" }} </label> <span class="required text-danger ml-1">*</span>
                            <ng-select *ngIf="!projectId" class="w-100 p-0 project-client-select"
                                       name="programManager" [items]="allClients" [(ngModel)]="clientsdatabinded"
                                       [multiple]="false" (change)="onRowSelect($event)" bindLabel="name"
                                       [clearSearchOnAdd]="true" [searchable]="true"
                                       [ngModelOptions]="{standalone: true}" placeholder="Select Client"
                                       [ngClass]="{ 'red-border': projectForm.submitted && !clientsdata }">

                                <ng-template ng-option-tmp let-item="item"
                                             let-index="index">

                                    <div class="row cursor-pointer w-100" (click)="onRowSelect(item)">
                                        <div class=" m-1 col-1">
                                            <img class="border border-light rounded p-1 h-40px w-40px" *ngIf="item.clientImageURL"
                                                 [src]="item.clientImageURL" id="profimgsize" />
                                            <img class="default-photo-size border border-light rounded p-1 h-40px w-40px" *ngIf="!item.clientImageURL"
                                                 src="assets/common/images/default-profile-picture1.svg"
                                                 id="profimgsize" />
                                        </div>
                                        <div class="col-2 font-12 mt-4">
                                            <b class="text-client-color" pTooltip="{{ item.name }}"
                                               [tooltipDisabled]="false" tooltipPosition="bottom">
                                                {{
                                                            item.name | slice:0:10
                                                }}{{
 item.name?.length > 10 ?
                                                            '..' : ''
                                                }}
                                            </b>
                                        </div>
                                        <div class="py-2 col-3">
                                            <div class="align-center ">
                                                <div>{{ "Name" | localize }}</div>
                                                <b class="d-block"
                                                   pTooltip="{{ projectService.getFullname(item.clientContacts[0]?.firstName, item.clientContacts[0]?.lastName) }}"
                                                   [tooltipDisabled]="false"
                                                   tooltipPosition="bottom">
                                                    {{
                                                                    projectService.getFullname(item.clientContacts[0]?.firstName,
                                                                    item.clientContacts[0]?.lastName) |
                                                                    slice:0:15
                                                    }}{{
projectService.getFullname(item.clientContacts[0]?.firstName,
                                                                    item.clientContacts[0]?.lastName).length > 15
                                                                    ? '..' : ''
                                                    }}
                                                </b>
                                            </div>

                                        </div>
                                        <div class="py-2 col-4">
                                            <div class="align-center ">
                                                <div>
                                                    {{ "Email" | localize }}
                                                </div>
                                                <b class="d-block"
                                                   pTooltip="{{ item.clientContacts[0]?.email }}"
                                                   [tooltipDisabled]="false" tooltipPosition="bottom">
                                                    {{ item.clientContacts[0]?.email | slice:0:18}}{{
                                                                item.clientContacts[0]?.email.length > 18 ? '..' :
                                                                ''
                                                    }}
                                                </b>
                                            </div>

                                        </div>
                                        <div class="py-2 col-1">
                                            <div class="align-center ">
                                                <div>
                                                    {{ "Phone" | localize }}
                                                </div>
                                                <b class="d-block">
                                                    {{
                                                                item.clientContacts[0]?.phoneNumber
                                                    }}
                                                </b>
                                            </div>

                                        </div>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <div *ngIf="projectForm.submitted && !(clientsdata != null)" class="text-danger" style="font-size: 0.9rem !important;">
                                Client is mandatory

                            </div>
                            <div class="w-100 d-flex align-items-center p-2 position-relative invite-user cursor-pointer border border-radius-2 assignclient selected-client-card"
                                 *ngIf="clientsdata != null && clientsdata.id"
                                 [ngClass]="{'cursor-pointer': !projectId}">
                                <div class="kt-align-center">
                                    <img class="border border-light rounded p-1 h-40px w-40px" *ngIf="clientsdata.clientImageURL" [src]="clientsdata.clientImageURL" alt="logo" id="profimgsize" />
                                    <img class="default-photo-size border border-light rounded p-1 h-40px w-40px" *ngIf="!clientsdata.clientImageURL"
                                         src="assets/common/images/default-profile-picture1.svg " id="profimgsize" />
                                </div>
                                <div class="ml-4 width-percent-30">
                                    <div class="row">
                                        <span class="font-12 m-2">
                                            <b class="smallSize m-2" pTooltip="{{ clientsdata.name }}"
                                               [tooltipDisabled]="false" tooltipPosition="bottom">
                                                {{clientsdata.name | slice:0:18}}{{(clientsdata.name).length > 18 ? '...' : ''}}
                                            </b>

                                        </span>
                                    </div>
                                </div>

                                <div class="ml-2 w-25">
                                    <div>
                                        <small class="smallSize font-10">{{ "Name" | localize }}</small>
                                        <b class="d-block smallSize"
                                           pTooltip="{{ projectService.getFullname( this.clientsdata.contactDetails?.firstName, this.clientsdata.contactDetails?.lastName) }}"
                                           [tooltipDisabled]="false" tooltipPosition="bottom">
                                            {{
                                                        projectService.getFullname(
                                                        this.clientsdata.contactDetails?.firstName,
                                                        this.clientsdata.contactDetails?.lastName) |
                                                        slice:0:15
                                            }}{{
projectService.getFullname(
                                                        this.clientsdata.contactDetails?.firstName,
                                                        this.clientsdata.contactDetails?.lastName).length > 15 ? '...' :
                                                        ''
                                            }}
                                        </b>
                                    </div>
                                </div>

                                <div class="ml-2 w-25">
                                    <div>
                                        <small class="smallSize font-10">{{ "Email" | localize }}</small>
                                        <small class="smallSize font-10">
                                            <b class="d-block smallSize" pTooltip="{{this.clientsdata.contactDetails?.email  }}"
                                               [tooltipDisabled]="false" tooltipPosition="bottom">
                                                {{ this.clientsdata.contactDetails?.email | slice:0:18}} {{(this.clientsdata.contactDetails?.email).length > 18 ? '...' : ''}}
                                            </b>

                                        </small>
                                    </div>
                                </div>

                                <div class="ml-2 w-25">
                                    <div>
                                        <small class="smallSize font-10">{{ "Phone" | localize }}</small>
                                        <small class="smallSize font-10">
                                            <b class="d-block smallSize">
                                                {{
                                                            this.clientsdata.contactDetails?.phoneNumber
                                                }}
                                            </b>
                                        </small>
                                    </div>
                                </div>

                                <button *ngIf="!projectId" type="button" class="close">
                                    <div class="col-1 px-0 pt-2 deletebtn "
                                         (click)="removeSelectedClient()">
                                        <img class="cursor-pointer"
                                             src="assets/common/images/projects/Delete_Icon.svg"
                                             width="15" />
                                    </div>
                                </button>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-12 mb-4 font-weight-bolder">{{ "ProjectTeamInformation" | localize }}</div>

                    <div class="col-md-6" *ngIf="true">
                        <div class="form-group" id="programManager">
                            <label> {{ "AssignProgramManager"| localize }} <span class="required text-danger"></span> </label>
                            <ng-select class="w-100 p-0" name="programManager" [(ngModel)]="programManager"
                                       [compareWith]="compareUserById"
                                       [multiple]="false" placeholder="Select Program Manager" (change)="addProgramManagerMember($event)" [ngClass]="{ 'btn-border': projectForm.submitted && programManager==null && false }">
                                <ng-option [value]="item" *ngFor="let item of ProgramManagerUsers; trackBy: trackById">
                                    <div class="d-flex">
                                        <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1 h-40px w-40px">
                                            <img src="{{ item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                                 class=" h-40px w-40px border border-light p-1 rounded" id="profimgsize">
                                        </div>

                                        <div class="flex-row justify-content-center ml-2 mr-4 ">
                                            <div class=" font-weight-bold font-size-14">
                                                <span pTooltip="{{ item.name}} {{item.surname}}"
                                                      [tooltipDisabled]="item.name?.length < 17"
                                                      tooltipPosition="bottom">{{ item.name.length > 17  ? item.name.slice(0,17)+'...': item.name +' ' +item.surname}}</span>
                                                <span class="text-muted ml-1" *ngIf="item.roles.length==1">
                                                    ({{item.roles[0]?.roleName}})
                                                </span>
                                                <span class="text-muted ml-1" *ngIf="item.roles.length !=1">
                                                    ({{item.roles[0]?.roleName}}, {{item.roles[1]?.roleName }})
                                                </span>
                                            </div>

                                            <div class="flex-column justify-content-start align-self-center font-weight-bold font-size-14" pTooltip="{{  item.emailAddress}}"
                                                 [tooltipDisabled]="false"
                                                 tooltipPosition="bottom">

                                                {{ item.emailAddress.length>50 ? item.emailAddress.slice(0,50)+'...': item.emailAddress}}
                                            </div>
                                        </div>
                                    </div>
                                </ng-option>

                            </ng-select>
                            <div *ngIf="programManager != null" class="border p-2 mt-5 rounded ">

                                <div class="row">
                                    <div class="col-2 d-flex justify-content-center align-items-center rounded w-40px h-40px">
                                        <img src="{{ programManager.profileImage ? programManager.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                             class=" h-40px w-40px border border-light p-1 rounded" id="profimgsize">
                                    </div>
                                    <div class=" col-9 d-flex align-items-start justify-content-center flex-column text-dark-75">
                                        <div class="font-weight-bold ">
                                            {{ programManager.name | titlecase }} {{programManager.surname | titlecase}}
                                        </div>

                                        <div style="font-size: 0.8rem;">
                                            {{ programManager.emailAddress }}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 font-size-sm">
                        <div class="form-group font-size-sm" id="projectManager">
                            <label>
                                {{ "Assign Project Managers" }} <span class="required text-danger">*</span>
                            </label>
                            <ng-select class="w-100 p-0 border rounded-2" name="projectManager"
                                       [items]="ProjectManagerUsers" bindLabel="fullName"
                                       [compareWith]="compareUserById"
                                       [(ngModel)]="projectManager" [multiple]="true" [closeOnSelect]="false"
                                       (add)="addProjectManagerMember($event)"
                                       placeholder="Select Project Managers"
                                       required
                                       (remove)="onProjectManagerMemberChanges($event)"
                                       [ngClass]="{ 'border border-danger': projectForm.submitted && projectManager.length == 0}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                             let-index="index">
                                    <div class="d-flex">
                                        <label class="checkbox mr-0">
                                            <input id="item-{{index}}" type="checkbox"
                                                   [ngModel]="item$.selected"
                                                   [ngModelOptions]="{standalone: true}" />
                                            <span (click)="checkUncheck(item$)"></span>
                                        </label>
                                        <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1 h-40px w-40px">
                                            <img src="{{ item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                                 class="h-40px w-40px border border-light p-1 rounded" id="profimgsize">
                                        </div>
                                        <div class="flex-row justify-content-center ml-2 mr-4 ">
                                            <div class=" font-weight-bold font-size-14">
                                                <span pTooltip="{{ item.name}} {{item.surname}}"
                                                      [tooltipDisabled]="item.name?.length < 17"
                                                      tooltipPosition="bottom">{{ item.name.length > 17  ? item.name.slice(0,17)+'...': item.name +' ' +item.surname}}</span>
                                                <span class="text-muted ml-1" *ngIf="item.roles.length==1">
                                                    ({{item.roles[0]?.roleName}})
                                                </span>
                                                <span class="text-muted ml-1" *ngIf="item.roles.length !=1">
                                                    ({{item.roles[0]?.roleName}}, {{item.roles[1]?.roleName }})
                                                </span>
                                            </div>

                                            <div class="flex-column justify-content-start align-self-center font-weight-bold font-size-14" pTooltip="{{  item.emailAddress}}"
                                                 [tooltipDisabled]="false"
                                                 tooltipPosition="bottom">

                                                {{ item.emailAddress.length>50 ? item.emailAddress.slice(0,50)+'...': item.emailAddress}}
                                            </div>
                                        </div>

                                    </div>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    <span class="d-flex align-items-center"
                                          style="width: 40px; height: 40px;">
                                        <img class="mr-1 h-40px w-40px p-1 border border-light rounded"
                                             [src]="item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg'" id="profimgsize" />
                                        {{item.name}}
                                    </span>
                                </ng-template>
                                <ng-template ng-typetosearch-tmp>
                                    <div class="ng-option disabled">
                                        Start typing...
                                    </div>
                                </ng-template>
                            </ng-select>
                            <div>
                                <div class="border p-2 mt-5 rounded"
                                     *ngFor="let pm of projectManager; let i = index; trackBy: trackByName">
                                    <div class="row">
                                        <div class="col-2 d-flex justify-content-center align-items-center rounded"
                                             style="width: 40px; height: 40px;">
                                            <img src="{{ pm.profileImage ? pm.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                                 class="h-40px w-40px border border-light p-1 rounded" id="profimgsize">
                                        </div>
                                        <div class=" col-9 d-flex align-items-start justify-content-center flex-column text-dark-75">
                                            <div class="font-weight-bold ">
                                                {{ pm.name | titlecase }} {{
                                                        pm.surname | titlecase
                                                }}
                                            </div>

                                            <div style="font-size: 0.8rem;" pTooltip="{{pm.emailAddress }}"
                                                 [tooltipDisabled]="(pm.emailAddress) | tooltipDisabled:47"
                                                 tooltipPosition="bottom">
                                                {{
 (pm.emailAddress &&
                                                        pm.emailAddress.length) > 47 ? pm.emailAddress.slice(0,47)+
                                                        ' ...' : pm.emailAddress
                                                }}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div *ngIf="projectForm.submitted && projectManager.length == 0" class="text-danger font-size-sm">
                                <div class="font-size-sm">
                                    {{"Project Manager is mandatory" | localize}}

                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="col-md-12">
                        <div class="form-group" id="AddTeamMembers">
                            <label>
                                {{ "Assign Team Members" }} <span class="required text-danger ml-1">*</span>
                            </label>
                            <ng-select class="w-100 p-0" name="projectTeam" [items]="usersData"
                                       [closeOnSelect]="false" [searchable]="true" bindLabel="fullName"
                                       [multiple]="true" [clearSearchOnAdd]="false" [clearOnBackspace]="false"
                                       [compareWith]="compareTeamMemberByUserId"
                                       [(ngModel)]="selectedTeamDropdown" (add)="addTeamMember($event)"
                                       (remove)="removeTeamMember($event)" placeholder="Select Team Member"
                                       [ngClass]="{ 'red-border': projectForm.submitted && listMember.length == 0 }">
                                <ng-template ng-header-tmp>
                                    <div class="row py-2">
                                        <div class="w-30px"></div>
                                        <div class="row w-100 px-3">
                                            <div class="col-md-6 pl-10 font-weight-bolder">
                                                Assign Team Members
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                             let-index="index">

                                    <div class="">

                                        <div class="d-sm-flex">
                                            <div class="col-1 p-4 px-5">
                                                <label class="checkbox mr-0">
                                                    <input id="item-tm-{{index}}" name="item-tm-{{index}}" type="checkbox"
                                                           [ngModel]="item$.selected"
                                                           [ngModelOptions]="{standalone: true}" />
                                                    <span (click)="checkUncheck(item$)"></span>
                                                </label>
                                            </div>
                                            <div class="col-2">
                                                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1 w-40px h-40px">
                                                    <img src="{{ item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg' }}" class="h-40px w-40px border border-light rounded p-1" id="profimgsize">
                                                </div>
                                            </div>

                                            <div class="col-3 py-2">
                                                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                                                    <div style="font-size: 0.9rem;">
                                                        Name :
                                                    </div>
                                                    <div class="font-weight-bold">
                                                        <span>
                                                            <b class="text-client-color"
                                                               pTooltip="{{ getFullname(item.name, item.surname) }}"
                                                               [tooltipDisabled]="false"
                                                               tooltipPosition="bottom">
                                                                {{
 getFullname(item.name, item.surname) |
                                                                    slice:0:15
                                                                }}{{
getFullname(item.name,
                                                                    item.surname).length > 15 ? '...' : ''
                                                                }}
                                                            </b>
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-3 py-2">
                                                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                                                    <div style="font-size: 0.9rem;">
                                                        Email :
                                                    </div>
                                                    <div style="font-size: 0.9rem;" pTooltip="{{ item.emailAddress }}" [tooltipDisabled]="false" tooltipPosition="bottom">
                                                        {{item.emailAddress | slice:0:21 }}{{item.emailAddress ?.length>21? '..': ''}}
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-3 py-2">
                                                <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                                                    <div style="font-size: 0.9rem;">
                                                        Phone No :
                                                    </div>
                                                    <div style="font-size: 0.9rem;">
                                                        {{item.phoneNumber ? item.phoneNumber : '-'}}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                    <span class="d-flex align-items-center">
                                        <img class="mr-1 h-40px w-40px border border-light rounded p-1" [src]="item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg'" id="profimgsize" />
                                        {{item.name}}
                                    </span>
                                </ng-template>
                            </ng-select>
                            <div *ngIf="projectForm.submitted" class="text-danger font-size-sm">
                                <span *ngIf="listMember.length == 0">
                                    {{ "Team Members are mandatory" | localize }}
                                </span>
                            </div>
                            <div class="overflow-auto ">
                                <p-table [value]="listMember" class="w-100 project-team-table" [scrollable]="true" scrollDirection="both">
                                    <ng-template pTemplate="header">
                                        <tr class="h-40" *ngIf="listMember.length !== 0">

                                            <th class="TeamHeader" style="min-width:175px;width:18%">
                                                <span class="font-weight-bold">
                                                    {{
 "MemberName" | localize
                                                    }}
                                                </span>
                                            </th>
                                            <th class="TeamHeader" style="min-width:180px;width:18%">
                                                <span class="font-weight-bold">
                                                    {{
 "ProjectRole" | localize
                                                    }}
                                                </span>
                                            </th>
                                            <th class="TeamHeader" style="min-width:165px;width:18%">
                                                <span class="font-weight-bold">
                                                    {{
 "StartDate" | localize
                                                    }}
                                                </span>
                                            </th>
                                            <th class="TeamHeader text-center" style="min-width:160px;width:18%">
                                                <div class="font-weight-bold">
                                                    {{
 'Daily'
                                                            | localize
                                                    }}
                                                </div>

                                                <div class="row no-gutters mt-1 mb-n2">
                                                    <div class="col-6  font-weight-lighter">
                                                        {{
                                                                "MinHrs" | localize
                                                        }}
                                                    </div>
                                                    <div class="col-6  font-weight-lighter">
                                                        {{
                                                                "MaxHrs" | localize
                                                        }}
                                                    </div>
                                                </div>
                                            </th>
                                            <th class="TeamHeader" style="min-width:165px;width:18%">
                                                <span class="font-weight-bold">
                                                    {{
 "EndDate" | localize
                                                    }}
                                                </span>
                                            </th>
                                            <th class="TeamHeader" style="min-width:40px;width:10%">
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-c="$implicit" let-i="rowIndex">
                                        <tr class="white">

                                            <td style="min-width:175px;width:18%" class="border-gray align-middle">
                                                <div class="row pl-2">

                                                    <div class="col-md-12 px-1 border rounded">
                                                        <div class="d-flex h-100">
                                                            <div class="col-md-5 col-lg-4 p-2 d-flex justify-content-center align-items-center h-auto flex-wrap w-100%">
                                                                <img class=" border border-light rounded p-1 h-40px w-40px"
                                                                     *ngIf="c.profileImage"
                                                                     [src]="c.profileImage" id="profimgsize" />
                                                                <img class=" border border-light rounded p-1"
                                                                     *ngIf="!c.profileImage"
                                                                     [src]="'assets/common/images/default-profile-picture1.svg'" width="40" height="40" id="profimgsize" />
                                                            </div>
                                                            <div class="col-md-7 col-lg-8 px-0  d-flex align-items-center flex-wrap py-4">
                                                                <div>
                                                                    <span>
                                                                        <b class="text-client-color"
                                                                           pTooltip="{{ getFullname(c.name, c.surname) }}"
                                                                           [tooltipDisabled]="false"
                                                                           tooltipPosition="bottom">
                                                                            {{
 getFullname(c.name,
                                                                                    c.surname) |
                                                                                    slice:0:15
                                                                            }}{{
getFullname(c.name,
                                                                                    c.surname).length > 15 ? '...' :
                                                                                    ''
                                                                            }}
                                                                        </b>
                                                                    </span>
                                                                </div>
                                                                <div>

                                                                    <span data-tooltip="{{ c.emailAddress }}" tooltipPlacement="bottom"
                                                                          style=" font-size: 12px;">
                                                                        {{
c.emailAddress
                                                                                |
                                                                                slice:0:14
                                                                        }}{{
c.emailAddress?.length>14?
                                                                                '...': ''
                                                                        }}
                                                                    </span>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td style="min-width:180px;width:18%" class="align-middle">
                                                <span>
                                                    <input class="form-control projectRole"
                                                           placeholder="Enter Project Role"
                                                           [(ngModel)]="c.projectRole" required
                                                           #projectRole{{i}}="ngModel"
                                                           name="projectRole{{i}}"
                                                           onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'
                                                           [ngClass]="{ 'red-border': projectForm.submitted && !c.projectRole }" />

                                                    <span *ngIf="projectForm.submitted && !c.projectRole"
                                                          class="text-danger font-size-sm">
                                                        {{"Project Role mandatory" | localize}}
                                                    </span>
                                                </span>
                                                <div class="d-flex mb-0 mt-1 justify-content-between">
                                                    <label class="mt-1">
                                                        {{
 "HourlyRate($)" | localize
                                                        }}
                                                    </label>
                                                    <input type="number" class="form-control ml-2 mt-2 w-65px"
                                                           min="0" (keypress)="keyPressAvoidNegative($event)"
                                                           #hourlyRates="ngModel"
                                                           [(ngModel)]="c.userBillingRate" required
                                                           #userBillingRate{{i}}="ngModel"
                                                           name="userBillingRate{{i}}" placeholder="$ 0.00"
                                                           [ngClass]="{ 'red-border': projectForm.submitted && hourlyRates.invalid  }" />

                                                </div>

                                                <div *ngIf="projectForm.submitted"
                                                     class="text-danger">
                                                    <div *ngIf="hourlyRates.invalid" class="text-danger font-size-sm">
                                                        {{"Hourly Rate mandatory" | localize}}

                                                    </div>

                                                </div>
                                            </td>

                                            <td style="min-width:165px;width:18%" class="align-middle project-member-date-cell">

                                                <div style="height: 40px;">
                                                    <div class="input-group date project-member-date-picker"
                                                         [ngClass]="{ 'red-border': projectForm.submitted && !c.startDate  }">
                                                        <input placement="auto" class="form-control m-input cursor-pointer"
                                                               id="enddate" type="text" name="enddate" [readonly]="true"
                                                               [readOnly]="true"
                                                               type="text" [(bsValue)]="c.startDate"
                                                               [minDate]="startdate ? startdate : minDate"
                                                               [maxDate]="c.endDate ? c.endDate : maxDate"
                                                               required bsDatepicker #dp4="bsDatepicker"
                                                               placeholder="{{dateFormat | uppercase}}"
                                                               value="{{ c.startDate | date:dateFormat }}"
                                                               [bsConfig]="{ showWeekNumbers: false, dateInputFormat: dateFormat | uppercase }"
                                                               (bsValueChange)="getMemberStartdate($event,i)" />
                                                        <div class="input-group-append cursor-pointer">
                                                            <label (click)="dp4.toggle()"
                                                                   [attr.aria-expanded]="dp4.isOpen"
                                                                   class="input-group-text cal p-2 cursor-pointer">
                                                                <i class="flaticon2-calendar-9"></i>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div *ngIf="projectForm.submitted && !c.startDate"
                                                         class="text-danger mt-1 font-size-sm">
                                                        {{"Enter Start Date" | localize}}

                                                    </div>

                                                </div>
                                            </td>

                                            <td style="min-width:160px;width:18%" class="p-0 m-0 align-middle team-hours-cell">
                                                <div class="team-hours-wrapper w-100">
                                                    <div class="row no-gutters d-flex justify-content-between">
                                                        <div class="col-lg-5 col-md-5 col-12">

                                                            <div class="input-group mb-1">
                                                                <div class="input-group-prepend cursor-pointer">
                                                                    <span class="input-group-text p-2" id="basic-addon1" (click)="onDecrement(i)">
                                                                        -
                                                                    </span>
                                                                </div>
                                                                <input type="number"
                                                                       min="0"
                                                                       [max]="maxDailyHours"
                                                                       [ngClass]="{ 'border-red':!isMinMaxValid(c.weeklyMinHrs, c.weeklyMaxHrs) || projectForm.submitted && (c.weeklyMinHrs == undefined || c.weeklyMinHrs == 0) }"
                                                                       [(ngModel)]="c.weeklyMinHrs"
                                                                       (ngModelChange)="onDailyMinHrsChange(c, $event)"
                                                                       required
                                                                       #weeklyMaxHrs{{i}}="ngModel"
                                                                       name="weeklyMinHrs{{i}}"
                                                                       (keypress)="keyPressAvoidNegative($event)"
                                                                       class="form-control  w-30px p-lg-3" />
                                                                <div class="input-group-append"
                                                                     [class.cursor-pointer]="c.weeklyMinHrs < maxDailyHours"
                                                                     [style.pointer-events]="c.weeklyMinHrs >= maxDailyHours ? 'none' : 'auto'"
                                                                     [style.opacity]="c.weeklyMinHrs >= maxDailyHours ? '0.5' : '1'">
                                                                    <span class="input-group-text p-1" (click)="onIncrementMinHrs(i)" id="basic-addon1">
                                                                        +
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="col-lg-5 col-md-5 col-12">

                                                            <div class="input-group mb-1">
                                                                <div class="input-group-prepend cursor-pointer">
                                                                    <span class="input-group-text p-2" id="basic-addon1" (click)="onDecrement1(i)">
                                                                        -
                                                                    </span>
                                                                </div>
                                                                <input type="number"
                                                                       [min]="c.weeklyMinHrs"
                                                                       [max]="maxDailyHours"
                                                                       [ngClass]="{ 'border-red':!isMinMaxValid(c.weeklyMinHrs, c.weeklyMaxHrs) || projectForm.submitted && (c.weeklyMaxHrs == undefined || c.weeklyMaxHrs == 0) }"
                                                                       [(ngModel)]="c.weeklyMaxHrs"
                                                                       (ngModelChange)="onDailyMaxHrsChange(c, $event)"
                                                                       required
                                                                       #weeklyMaxHrs{{i}}="ngModel"
                                                                       name="weeklyMaxHrs{{i}}"
                                                                       (keypress)="keyPressAvoidNegative($event)"
                                                                       class="form-control  w-30px p-lg-3" />
                                                                <div class="input-group-append"
                                                                     [class.cursor-pointer]="c.weeklyMaxHrs < maxDailyHours"
                                                                     [style.pointer-events]="c.weeklyMaxHrs >= maxDailyHours ? 'none' : 'auto'"
                                                                     [style.opacity]="c.weeklyMaxHrs >= maxDailyHours ? '0.5' : '1'">
                                                                    <span class="input-group-text p-1" (click)="onIncrementMaxHrs(i)" id="basic-addon1">
                                                                        +
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="team-hours-validation">
                                                        <div class="text-danger mt-1 font-size-sm"
                                                             *ngIf="isDailyHoursExceedingLimit(c.weeklyMinHrs, c.weeklyMaxHrs)">
                                                            Daily hours cannot exceed 24.
                                                        </div>
                                                        <div class="text-danger mt-1 font-size-sm"
                                                             *ngIf="!isDailyHoursExceedingLimit(c.weeklyMinHrs, c.weeklyMaxHrs) && isMinMaxOrderInvalid(c.weeklyMinHrs, c.weeklyMaxHrs)">
                                                            Min Hrs > Max Hrs
                                                        </div>
                                                        <div class="text-danger mt-1 font-size-sm"
                                                             *ngIf="projectForm.submitted && (c.weeklyMaxHrs == undefined || c.weeklyMinHrs == undefined || c.weeklyMaxHrs == 0 || c.weeklyMinHrs == 0)">
                                                            Min Hrs and Max Hrs are mandatory
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td style="min-width:165px;width:20%" class="align-middle project-member-date-cell">
                                                <div style="height: 40px;">

                                                    <div class="input-group date project-member-date-picker" [ngClass]="{ 'red-border': projectForm.submitted && !c.endDate  }">
                                                        <input placement="auto" class="form-control m-input cursor-pointer" type="text"
                                                               [(bsValue)]="c.endDate" [minDate]="c.startDate ? c.startDate : minDate" [maxDate]="maxDate" [readonly]="true"
                                                               required bsDatepicker #dp3="bsDatepicker" placeholder="{{dateFormat | uppercase}}"
                                                               value="{{ c.endDate | date:dateFormat }}"
                                                               [bsConfig]="{ showWeekNumbers: false, dateInputFormat: dateFormat | uppercase }"
                                                               (bsValueChange)="getMemberEnddate($event,i)" />
                                                        <div class="input-group-append cursor-pointer">
                                                            <label (click)="dp3.toggle()" [attr.aria-expanded]="dp3.isOpen"
                                                                   class="input-group-text cal p-2 cursor-pointer">
                                                                <i class="flaticon2-calendar-9"></i>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div *ngIf="projectForm.submitted && !c.endDate" class="text-danger mt-1 font-size-sm">
                                                        {{"Enter End Date" | localize}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="width:40px;width:10%" class="align-middle">
                                                <div class="">
                                                    <img class="cursor-pointer" (click)="deletelist(c, i)"
                                                         src="assets/common/images/projects/Delete_Icon.svg"
                                                         width="15" />
                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 mb-4 font-weight-bolder">Project Services Information</div>

                    <div class="col-md-12" id="projectServices">
                        <div class="form-group">
                            <label>
                                {{ "Assign Products/Services" }}<span class="required text-danger ml-1">*</span>
                            </label>
                            <ng-select class="w-100 p-0" name="prodServs"
                                       [items]="productServiceRecords" dropdownPosition="top"
                                       [closeOnSelect]="false" bindLabel="name"
                                       [(ngModel)]="selectedProductServiceRecords" (add)="addService($event)"
                                       (remove)="removeService($event)" [multiple]="true"
                                       [ngModelOptions]="{standalone: true}" placeholder="Select Products/Services"
                                       [ngClass]="{ 'red-border': projectForm.submitted && serviceList.length == 0 }">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                             let-index="index">
                                    <div class="d-flex">
                                        <label class="checkbox mr-0">
                                            <input id="item-{{index}}" type="checkbox"
                                                   [ngModel]="item$.selected"
                                                   [ngModelOptions]="{standalone: true}" />
                                            <span (click)="checkUncheck(item$)"></span>
                                        </label>
                                        <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1 w-40px h-40px">

                                            <img *ngIf="item.productServiceTypeId == 1"
                                                 [src]="item.productServiceImage ? item.productServiceImage : 'assets/common/images/product/DefaultProduct.png'"
                                                 class="w-40px h-40px border border-light rounded p-1" id="profimgsize" />
                                            <img *ngIf="item.productServiceTypeId == 2"
                                                 [src]="item.productServiceImage ? item.productServiceImage : 'assets/common/images/product/Services.svg'"
                                                 class="w-40px h-40px border border-light rounded p-1" id="profimgsize" />
                                        </div>
                                        <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                                            <div class="font-weight-bold" pTooltip="{{item.name }}"
                                                 [tooltipDisabled]="(item.name) | tooltipDisabled:20"
                                                 tooltipPosition="bottom">
                                                {{ (item.name && item.name.length) > 20 ? item.name.slice(0,20)+ ' ...' :  item.name | titlecase }}
                                            </div>
                                            <div style="font-size: 0.8rem;" pTooltip="{{item.description }}"
                                                 [tooltipDisabled]="(item.description) | tooltipDisabled:120"
                                                 tooltipPosition="bottom">
                                                {{ (item.description && item.description.length) > 120 ? item.description.slice(0,120)+ ' ...' :  item.description | titlecase }}
                                            </div>
                                        </div>

                                    </div>
                                </ng-template>

                            </ng-select>
                            <div *ngIf="projectForm.submitted" class="text-danger font-size-sm" id="error-message">
                                <span *ngIf="serviceList.length == 0">
                                    {{ "Products/Services are mandatory" | localize }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row col-md-12 mb-5">
                        <div *ngFor="let c of serviceList; let i = index; trackBy: trackByUserId" class="rounded col-4 mb-3">
                            <div #dataTableservice class="row no-gutters selected-team-border">

                                <div class="col-2">
                                    <img *ngIf="c.productServiceTypeId == 1"
                                         [src]="c.productServiceImage ? c.productServiceImage : 'assets/common/images/product/DefaultProduct.png'"
                                         class="h-20px w-20px border border-light rounded p-1" id="profimgsize" />
                                    <img *ngIf="c.productServiceTypeId == 2"
                                         [src]="c.productServiceImage ? c.productServiceImage : 'assets/common/images/product/Services.svg'"
                                         class="h-20px w-20px border border-light rounded p-1" id="profimgsize" />
                                </div>
                                <div class="col-8 vertically-centered">
                                    <span pTooltip="{{c.name }}" tooltipPosition="bottom">

                                        {{ (c.name && c.name.length) > 20 ? c.name.slice(0,20)+ ' ...' :  c.name }}
                                    </span>
                                </div>
                                <div class="col-2">
                                    <button type="button" class="close font-weight-bolderer font-12">
                                        <i class="la la-times text-danger font-weight-bolder"
                                           (click)="hideProdService(c, i)"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>

        <div id="createoreditsettings" class="col-xl-4 col-12 right_section pt-5 mb-5 pb-7">
            <div>
                <div class="d-flex ml-1">
                    <h6>{{ "Settings" | localize }}</h6>
                    <div class="font-size-xs font-weight-bold ml-3 pt-1">
                        <span placement="left" [tooltip]="tooltipmsg" placement="bottom">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                            </svg>
                        </span>
                        <ng-template #tooltipmsg class="">
                            {{ "ChangessettingsrelatedtoProjecttype" | localize }}
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="border">

                <div class="accordion accordion-light " id="accordionSettings">
                    <div class="">
                        <div class="card">
                            <div class="card-header" id="headingOne">
                                <div id="collapse_icon" class="card-title collapsed "
                                     (click)="accordianOpen(0)">
                                    <div class=" row w-100 ml-3 mr-1">
                                        <div class="col-2 ">
                                            <img src="assets/common/images/projects/allProjectIcon.svg" alt="logo"
                                                 height="25" class="mr-2" />
                                        </div>
                                        <div class="col-10 px-0">
                                            <div class="">
                                                <h6 class="kt-font-bold m-0 font-14">
                                                    {{"Projecttype" | localize}}
                                                </h6>
                                            </div>
                                            <div *ngIf="projectType === 1"
                                                 class="kt-padding-t-1 forecolor font-weight-lighter"
                                                 for="flatRateProject">
                                                {{ "FlatRateProjectTypeNew" | localize }}

                                            </div>
                                            <div *ngIf="projectType === 2"
                                                 class="kt-padding-t-1 forecolor font-weight-lighter"
                                                 for="percentage">
                                                {{ "HourlyProjectTypeNew" | localize }}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                                 data-parent="#accordionSettings">
                                <div class="card-body Collapsed-panel-color p-3">
                                    <div class="kt-radio-list ml-3">
                                        <div class="font-size-sm kt-padding-t-10 pb-4 forecolor font-14">
                                            {{ "WhattypeofProject" | localize }}
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input w-20px h-20px mt-4 radio_button"
                                                   type="radio" name="isLateFee" value="true"
                                                   [checked]="projectType === 1" (click)="setProjectType(1)"
                                                   id="flatRateProject" />
                                            <div class="ml-5 pt-1 font-weight-bolder">
                                                <label class=" m-0  ml-5">
                                                    {{
   "FlatRateProjectTypeNew" | localize
                                                    }}
                                                </label>
                                            </div>
                                            <div class="kt-font-md kt-padding-t-1 forecolor ml-10 pb-3 font-14">
                                                {{ "Iamchargingflatrateforthisproject" | localize }}
                                            </div>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input w-20px h-20px mt-4 radio_button"
                                                   type="radio" name="isLateFee" value="false"
                                                   [checked]="projectType === 2" (click)="setProjectType(2)"
                                                   id="percentage" />
                                            <div class="ml-5 pt-1 font-weight-bolder">
                                                <label class=" m-0  ml-5">
                                                    {{
   "HourlyProjectTypeNew" | localize
                                                    }}
                                                </label>
                                            </div>
                                            <div class="kt-font-md kt-padding-t-1 forecolor ml-10 pb-3 font-14">
                                                {{ "Iamchargingbythehourlyforthisproject" | localize }}
                                            </div>
                                        </div>
                                        <div *ngIf="projectType === 2">
                                            <div>
                                                <h6 class="mb-0 fs-6 pb-2 pl-0 pt-4 text-uppercase forecolor font-14">
                                                    {{ "SetHourlyRates" | localize }}
                                                </h6>
                                            </div>

                                            <hr class="mt-0" />
                                            <div class="col-md-12 p-0">
                                                <div class="form-group billing_method">
                                                    <h6 class="fs-6 forecolor">
                                                        {{
                                                                    "SelectaBillingMethod" | localize
                                                        }}
                                                    </h6>
                                                    <ng-select class="width-percent-100"
                                                               [items]="serviceDropdown" bindLabel="name"
                                                               bindValue="id" name="name" [(ngModel)]="serviceID"
                                                               [multiple]="false"
                                                               [ngModelOptions]="{ standalone: true }"
                                                               placeholder="Select Rates">
                                                        <ng-template ng-option-tmp let-item="item"
                                                                     let-item$="item$" let-index="index"
                                                                     class="font-weight-bolder">
                                                            <div class="font-weight-bolder text-black">
                                                                {{
                                                                            item.name
                                                                }}
                                                            </div>
                                                            <small class="font-weight-bolder text-black">
                                                                {{
                                                                            item.discription
                                                                }}
                                                            </small>
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </div>
                                            <div *ngIf="serviceID==0">
                                                <div class="col-md-12">
                                                    <h6 class="font-12 forecolor font-14">
                                                        {{'SingleHourlyRate' | localize}}
                                                    </h6>
                                                    <div class="d-flex mb-2">
                                                        <input type="number" class="form-control"
                                                               min="0"
                                                               name="singleRatePerHour"
                                                               (keypress)="onlyNumberKey($event)"
                                                               [(ngModel)]="project.singleRatePerHour"
                                                               placeholder="{{('$ 0.00' | localize)}}" required
                                                               autocomplete="off" />
                                                        <label class="mt-3 ml-3 font-12 forecolor">
                                                            /{{
'hr' |
                                                                        localize
                                                            }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="serviceID==1">
                                                <div class="col-md-12 p-0">
                                                    <h6 class="mb-0 font-12 text-uppercase font-14 ">
                                                        {{'TeamMemberRates' | localize}}
                                                    </h6>
                                                    <hr class="mt-0" />
                                                    <div class="  mb-2 row mt-1 mb-1">
                                                        <div class="col-sm-12 col-md-12 col-lg-12"
                                                             *ngFor="let c of listMember;let i = index; trackBy: trackByUserId">
                                                            <div class="">
                                                                <div class="shadow-none border mouse-over cursor-pointer p-3 mb-5">
                                                                    <div class="row">
                                                                        <div class="col-sm-12 col-lg-12 col-md-12 d-flex  justify-content-between">
                                                                            <div class="d-flex">
                                                                                <div class="photo-background kt-align-center w-60px h-60px">
                                                                                    <img class="service-width-img  w-60px h-60px"
                                                                                         *ngIf="c.profilePictureId != null"
                                                                                         [src]="c.profilePictureId">
                                                                                    <img class="default-photo-size  w-60px h-60px"
                                                                                         *ngIf="c.profilePictureId == null"
                                                                                         src="assets/common/images/default-profile-picture1.svg"
                                                                                         width="47"
                                                                                         height="57">
                                                                                </div>

                                                                                <div class="ml-6">
                                                                                    <div class="row">
                                                                                        <label class="photo-textsize mb-0 font-weight-bolder1 font-14">
                                                                                            {{c.name}}
                                                                                            {{c.surname}}
                                                                                        </label>
                                                                                    </div>
                                                                                    <div Class='row'>
                                                                                        <small class="smallSize">{{selectedTeamMember(c.userId)}}</small>
                                                                                    </div>
                                                                                    <div class="row mt-0 mb-1">
                                                                                        <div class="mt-1 photo-email-text font-14">
                                                                                            {{c.emailAddress}}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 position-absolute right-0 mt-3">
                                                                                <input type="number"
                                                                                       class="form-control"
                                                                                       min="0"
                                                                                       name="teamMemberRate{{i}}"
                                                                                       (keypress)="onlyNumberKey($event)"
                                                                                       [(ngModel)]="c.userBillingRate"
                                                                                       placeholder="{{('$ 0.00' | localize)}}"
                                                                                       required
                                                                                       autocomplete="off" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="serviceID==2">
                                                <div class="mt-4">
                                                    <h6 class="mb-0 font-12 text-uppercase font-14">
                                                        {{'ServiceRates' | localize}}
                                                    </h6>
                                                </div>
                                                <hr class="mt-0" />
                                                <div class="row mt-1 mb-1">
                                                    <div class="col-12"
                                                         *ngFor="let c of serviceList;let i = index; trackBy: trackByUserId">
                                                        <div class="p-2">
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <label class="">{{c.name}}</label>
                                                                </div>
                                                                <div class="col-12">
                                                                    <input type="text" class="form-control"
                                                                           name="flatrate{{i}}"
                                                                           (keypress)="onlyNumberKey($event)"
                                                                           [(ngModel)]="c.projectBillingServiceRate"
                                                                           placeholder="{{('$ 0.00' | localize)}}"
                                                                           required autocomplete="off"
                                                                           disabled />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card" [ngClass]="{'red-border' :showIsCommercialsError}">
                            <div class="card-header" id="headingFive">
                                <div id="collapse_icon" class="card-title collapsed "
                                     (click)="accordianOpen(4)">
                                    <div class=" row w-100 ml-3 mr-1">
                                        <div class="col-2 ">
                                            <img src="assets/common/images/addTaxes.svg" alt="logo"
                                                 height="25" class="mr-2" />
                                        </div>
                                        <div class="col-10 px-0">
                                            <div class="">
                                                <div class="kt-font-bold">
                                                    <h6 class="kt-font-bold m-0">
                                                        {{ "Commercials" | localize}}<span class="text-danger  ml-1">*</span>
                                                    </h6>
                                                </div>
                                            </div>
                                            <div class="kt-padding-t-1 forecolor font-weight-lighter">
                                                {{ "Manage Project Duration ,Billability and more" | localize }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive"
                                 data-parent="#accordionSettings">
                                <div class="card-body Collapsed-panel-color p-3">
                                    <div class="kt-radio-list ml-3">
                                        <div class="form-group">
                                            <label>
                                                {{ "Project Duration (In Hours)" }} <span class="required text-danger ml-1">*</span>
                                            </label>
                                            <input type="number" (keypress)="onlyNumberKey($event)"
                                                   class="form-control"
                                                   oninput="if(this.value.length>=6) { this.value = this.value.slice(0,6); }"
                                                   #hourlyBudget="ngModel"
                                                   name="ProjectDuration"
                                                   [(ngModel)]="project.hourlyBudget"
                                                   (ngModelChange)="onProjectHoursChange()"
                                                   placeholder="{{ '00 Hrs' | localize }}"
                                                   autocomplete="off"
                                                   [ngClass]="{'red-border' : !projDurationValid || ( projectForm.submitted && hourlyBudget.invalid)}" required />
                                        </div>
                                        <div class="form-group">
                                            <div class="form-group" *ngIf="projectType === 1">
                                                <label> {{ "Flat Rate ($)" }} <span class="required text-danger ml-1">*</span></label>
                                                <input type="number"
                                                       class="form-control"
                                                       min="0"
                                                       #flatRate="ngModel"
                                                       [(ngModel)]="project.flatRate"
                                                       name="flatRate"
                                                       (keypress)="onlyNumberKey($event)"
                                                       placeholder="{{ '$ 0.00' | localize }}"
                                                       autocomplete="off"
                                                       [ngClass]="{'red-border' : projectForm.submitted && flatRate.invalid}" required />
                                                <div *ngIf="projectForm.submitted" style="font-size: 0.9rem !important;">
                                                    <div *ngIf="flatRate.invalid || project.flatRate <= 0" class="text-danger">
                                                        Flat Rate is mandatory and must be greater than 0
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group" *ngIf="projectType === 2">
                                                <label> {{ "Hourly Rate ($)" }} <span class="required text-danger"> * </span></label>
                                                <input type="number"
                                                       class="form-control"
                                                       min="0"
                                                       oninput="if(this.value.length>=6) { this.value = this.value.slice(0,6); }"
                                                       #hourlyRate="ngModel"
                                                       [(ngModel)]="project.singleRatePerHour"
                                                       name="hourlyRate"
                                                       (keypress)="onlyNumberKey($event)"
                                                       placeholder="{{ '$ 0.00' | localize }}"
                                                       autocomplete="off"
                                                       [ngClass]="{'red-border' : projectForm.submitted && hourlyRate.invalid}" required />
                                                <div *ngIf="projectForm.submitted" style="font-size: 0.9rem !important;">
                                                    <div *ngIf="hourlyRate.invalid ||  project.singleRatePerHour <= 0" class="text-danger">
                                                        Hourly rate is mandatory and must be greater than 0
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="projectType === 2">
                                            <div>
                                                <h6 class="mb-0 fs-6 pb-2 pl-0 pt-4 text-uppercase forecolor font-14">
                                                    {{ "SetHourlyRates" | localize }}
                                                </h6>
                                            </div>

                                            <hr class="mt-0" />
                                            <div class="col-md-12 p-0">
                                                <div class="form-group billing_method">
                                                    <h6 class="fs-6 forecolor">
                                                        {{
                                                                    "SelectaBillingMethod" | localize
                                                        }}
                                                    </h6>
                                                    <ng-select class="width-percent-100"
                                                               [items]="serviceDropdown" bindLabel="name"
                                                               bindValue="id" name="name" [(ngModel)]="serviceID"
                                                               [multiple]="false"
                                                               [ngModelOptions]="{ standalone: true }"
                                                               placeholder="Select Rates">
                                                        <ng-template ng-option-tmp let-item="item"
                                                                     let-item$="item$" let-index="index"
                                                                     class="font-weight-bolder">
                                                            <div class="font-weight-bolder text-black">
                                                                {{
                                                                            item.name
                                                                }}
                                                            </div>
                                                            <small class="font-weight-bolder text-black">
                                                                {{
                                                                            item.discription
                                                                }}
                                                            </small>
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </div>
                                            <div *ngIf="serviceID==0">
                                                <div class="col-md-12">
                                                    <h6 class="font-12 forecolor font-14">
                                                        {{'SingleHourlyRate' | localize}}
                                                    </h6>
                                                    <div class="d-flex mb-2">
                                                        <input type="number" class="form-control"
                                                               min="0"
                                                               name="singleRatePerHour"
                                                               (keypress)="onlyNumberKey($event)"
                                                               [(ngModel)]="project.singleRatePerHour"
                                                               placeholder="{{('$ 0.00' | localize)}}" required
                                                               autocomplete="off" />
                                                        <label class="mt-3 ml-3 font-12 forecolor">
                                                            /{{
'hr' |
                                                                        localize
                                                            }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="serviceID==1">
                                                <div class="col-md-12 p-0">
                                                    <h6 class="mb-0 font-12 text-uppercase font-14 ">
                                                        {{'TeamMemberRates' | localize}}
                                                    </h6>
                                                    <hr class="mt-0" />
                                                    <div class="  mb-2 row mt-1 mb-1">
                                                        <div class="col-sm-12 col-md-12 col-lg-12"
                                                             *ngFor="let c of listMember;let i = index; trackBy: trackByUserId">
                                                            <div class="">
                                                                <div class="shadow-none border mouse-over cursor-pointer p-3 mb-5">
                                                                    <div class="row">
                                                                        <div class="col-sm-12 col-lg-12 col-md-12 d-flex  justify-content-between">
                                                                            <div class="d-flex">
                                                                                <div class="photo-background kt-align-center w-60px h-60px">
                                                                                    <img class="service-width-img  w-60px h-60px"
                                                                                         *ngIf="c.profilePictureId != null"
                                                                                         [src]="c.profilePictureId">
                                                                                    <img class="default-photo-size  w-60px h-60px"
                                                                                         *ngIf="c.profilePictureId == null"
                                                                                         src="assets/common/images/default-profile-picture1.svg"
                                                                                         width="47"
                                                                                         height="57">
                                                                                </div>

                                                                                <div class="ml-6">
                                                                                    <div class="row">
                                                                                        <label class="photo-textsize mb-0 font-weight-bolder1 font-14">
                                                                                            {{c.name}}
                                                                                            {{c.surname}}
                                                                                        </label>
                                                                                    </div>
                                                                                    <div Class='row'>
                                                                                        <small class="smallSize">{{selectedTeamMember(c.userId)}}</small>
                                                                                    </div>
                                                                                    <div class="row mt-0 mb-1">
                                                                                        <div class="mt-1 photo-email-text font-14">
                                                                                            {{c.emailAddress}}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 position-absolute right-0 mt-3">
                                                                                <input type="number"
                                                                                       class="form-control"
                                                                                       min="0"
                                                                                       name="teamMemberRate{{i}}"
                                                                                       (keypress)="onlyNumberKey($event)"
                                                                                       [(ngModel)]="c.userBillingRate"
                                                                                       placeholder="{{('$ 0.00' | localize)}}"
                                                                                       required
                                                                                       autocomplete="off" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="serviceID==2">
                                                <div class="mt-4">
                                                    <h6 class="mb-0 font-12 text-uppercase font-14">
                                                        {{'ServiceRates' | localize}}
                                                    </h6>
                                                </div>
                                                <hr class="mt-0" />
                                                <div class="row mt-1 mb-1">
                                                    <div class="col-12"
                                                         *ngFor="let c of serviceList;let i = index; trackBy: trackByUserId">
                                                        <div class="p-2">
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <label class="">{{c.name}}</label>
                                                                </div>
                                                                <div class="col-12">
                                                                    <input type="text" class="form-control"
                                                                           name="flatrate{{i}}"
                                                                           (keypress)="onlyNumberKey($event)"
                                                                           [(ngModel)]="c.projectBillingServiceRate"
                                                                           placeholder="{{('$ 0.00' | localize)}}"
                                                                           required autocomplete="off"
                                                                           disabled />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                        <label>
                                            Project Status <span class="required text-danger ml-1">*</span>
                                        </label>
                                        <ng-select [items]="projectStatusInfo" bindLabel="name" bindValue="id"
                                                required [(ngModel)]="projectStatusSelected" [closeOnSelect]="true"
                                                [multiple]="false" placeholder="Select project status"
                                                [ngModelOptions]="{ standalone: true }" [disabled]="!projectId"
                                                [ngClass]="{'red-border' : projectForm.submitted && !projectStatusSelected}">

                                            <!-- Label template -->
                                            <ng-template ng-label-tmp let-item="item">
                                                <span class="d-flex align-items-center">
                                                    <img height="19" width="19" class="mr-1"
                                                        src="{{ item.icon }}" />
                                                    {{ item.name }}
                                                </span>
                                            </ng-template>
                                            <!-- Option template -->
                                            <ng-template ng-option-tmp let-item="item">
                                                <span class="d-flex align-items-center">
                                                    <img height="19" width="19" class="mr-1"
                                                        src="{{ item.icon }}" />
                                                    {{ item.name }}
                                                </span>
                                            </ng-template>
                                        </ng-select>
                                        <div *ngIf="projectForm.submitted"
                                            style="font-size: 0.9rem !important;">
                                            <div *ngIf="!projectStatusSelected" class="text-danger">
                                                Project status is mandatory
                                            </div>
                                        </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label> {{ "Start Date" }} </label>
                                                        <span class="required text-danger ml-1">*</span>
                                                        <div class="input-group date"
                                                             [ngClass]="{ 'red-border': projectForm.submitted && !startdate }">
                                                            <input placement="auto" class="form-control m-input cursor-pointer"
                                                                   id="startdate" type="text" name="startdate" [readonly]="true"
                                                                   [maxDate]="enddate ? enddate : maxDate" bsDatepicker
                                                                   [(ngModel)]="startdate"
                                                                   placeholder="{{dateFormat | uppercase}}"
                                                                   (bsValueChange)="getStartdate($event)" #dp="bsDatepicker"
                                                                   [bsConfig]="{ showWeekNumbers: false, dateInputFormat: bsDateFormat }" />
                                                            <div class="input-group-append cursor-pointer">
                                                                <label (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen"
                                                                       class="input-group-text cursor-pointer cal">
                                                                    <i class="flaticon2-calendar-9"></i>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div *ngIf="projectForm.submitted && !startdate" class="text-danger"
                                                             style="font-size: 0.9rem !important;">
                                                            <span>{{ "Start Date is mandatory" | localize }}</span>
                                                        </div>
                    
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <div class="form-group">
                                                        <label> {{ "End Date" }} </label>
                                                        <span class="required text-danger ml-1">*</span>
                                                        <div class="input-group date"
                                                             [ngClass]="{ 'red-border': projectForm.submitted && !enddate }">
                                                            <input placement="auto" autocomplete="off" class="form-control m-input cursor-pointer"
                                                                   id="enddate" type="text" name="enddate" [readonly]="true"
                                                                   [minDate]="getEndDateMin()" bsDatepicker
                                                                   [(ngModel)]="enddate"
                                                                   placeholder="{{dateFormat | uppercase}}"
                                                                   (bsValueChange)="getEnddate($event)" #dp2="bsDatepicker"
                                                                   [bsConfig]="{ showWeekNumbers: false, dateInputFormat: bsDateFormat }" />
                                                            <div class="input-group-append cursor-pointer">
                                                                <label (click)="dp2.toggle()" [attr.aria-expanded]="dp2.isOpen"
                                                                       class="input-group-text cursor-pointer cal">
                                                                    <i class="flaticon2-calendar-9"></i>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div *ngIf="projectForm.submitted && !enddate" class="text-danger"
                                                             style="font-size: 0.9rem !important;">
                                                            <span>{{ "End Date is mandatory" | localize }}</span>
                                                        </div>
                                                        <span *ngIf="endDateValid" class="text-danger">
                                                            {{"End date must be greater than start date"}}
                                                        </span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>{{ "Billability" | localize }}</label>
                                            <span class="required text-danger ml-1">*</span>
                                            <ng-select class="width-percent-100" name="Billability"
                                                       [items]="projectBillableTypes" bindLabel="name" bindValue="id"
                                                       [(ngModel)]="projectBillableSelected" #Billability="ngModel"
                                                       [closeOnSelect]="true" [multiple]="false"
                                                       placeholder="Select Billability Type"
                                                       [ngClass]="{ 'red-border': projectForm.submitted && !projectBillableSelected }">
                                                <ng-template ng-label-tmp let-item="item">
                                                    <span class="d-flex align-items-center">
                                                        <img *ngIf="item.name==='Billable'"
                                                             src="assets/common/images/billable.png" alt=""
                                                             width="15px" class="mr-1">
                                                        <img *ngIf="item.name==='Non-Billable'"
                                                             src="assets/common/images/nonbillable.png" alt=""
                                                             width="15px" class="mr-1">
                                                        {{item.name | localize}}
                                                    </span>
                                                </ng-template>
        
                                                <ng-template ng-option-tmp let-item="item">
                                                    <span class="d-flex align-items-center">
                                                        <img *ngIf="item.name==='Billable'"
                                                             src="assets/common/images/billable.png" alt=""
                                                             width="15px" class="mr-1">
                                                        <img *ngIf="item.name==='Non-Billable'"
                                                             src="assets/common/images/nonbillable.png" alt=""
                                                             width="15px" class="mr-1">
                                                        {{item.name | localize}}
                                                    </span>
                                                </ng-template>
                                            </ng-select>
                                            <div *ngIf="projectForm.submitted" class="text-danger"
                                                 style="font-size: 0.9rem !important;">
                                                <span *ngIf="projectBillableSelected == null">
                                                    {{ "Billabilityismandatory" | localize }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="form-group" *ngIf="projectBillableSelected === 1">
                                            <div class="row" [ngClass]="{ 'red-border': projectForm.submitted && projectbillabityAccess == '0'  }">
                                                <div class="col" >
                                                    <label>{{ "BillabilityStatusAuthority" | localize }}</label>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" value="1" name="flexRadioDefault" id="flexRadioDefault1"
                                                         [(ngModel)]="projectbillabityAccess"
                                                        (change)="updatevalue(editProject, $event)">
                                                        
                                                        <label class="form-check-label" for="flexRadioDefault1">
                                                          Manager
                                                        </label>
                                                      </div>
                                                </div>
                                                <div class="col">
                                                    <div class="form-check mt-8">
                                                        <input class="form-check-input" type="radio"  value="2" name="flexRadioDefault" id="flexRadioDefault2" 
                                                         [(ngModel)]="projectbillabityAccess"
                                                        (change)="updatevalue(editProject ,$event)">
                                                        <label class="form-check-label" for="flexRadioDefault2">
                                                            Employee
                                                        </label>
                                                    </div>
                                                 </div>
                                                 <div *ngIf="projectForm.submitted" class="text-danger"
                                                 style="font-size: 0.9rem !important;">
                                                <span *ngIf="projectbillabityAccess == '0'">
                                                    {{ "Billabilityismandatory" | localize }}
                                                </span>
                                            </div>
                                             </div>  
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                        </div>

                        <div class="card" [ngClass]="{'red-border' :showIsTimeOffLevel1Error}">
                            <div class="card-header" id="headingFour">
                                <div id="collapse_icon" class="card-title collapsed"
                                     (click)="accordianOpen(3)">
                                    <div class="row ml-3 w-100">
                                        <div class="col-2">
                                            <img src="assets/common/images/timeOffApproval Icon.svg"
                                                 alt="logo" height="25" class="mr-2" />
                                        </div>
                                        <div class="col-9 px-0">
                                            <div class="kt-font-bold">
                                                <h6 class="kt-font-bold m-0">
                                                    {{
 "LeaveApprovals" |
                                                                localize
                                                    }}<span class="text-danger  ml-1">*</span>
                                                </h6>
                                            </div>
                                            <div class="kt-padding-t-1 forecolor font-weight-lighter">
                                                {{ "ManageTeamsLeavesHolidayAwayTime" | localize }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                                 data-parent="#accordionSettings">
                                <div class="card-body Collapsed-panel-color pb-0">
                                    <div class="ml-3">

                                        <project-time-off-approval (onApproverType1event)="projectTimeoffselection($event)" (dataChange)="showValidation($event)"
                                                                   [projectTimeOffEdit]="editProject?.projectTimeOff" [usersData]="userRecords"
                                                                   [projectFormSubmitted]="projectFormSubmitted" [ProjectTeam]="filteredUsers">
                                        </project-time-off-approval>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card" [ngClass]="{'red-border' :showIsTimesheetLevel1Error}">
                            <div class="card-header" id="headingThree">
                                <div id="collapse_icon" class="card-title collapsed "
                                     (click)="accordianOpen(2)">

                                    <div class="row ml-3 mr-2 w-100">
                                        <div class="col-2">
                                            <img src="assets/common/images/time-sheet/ApprovalsIconNew.svg"
                                                 alt="logo" height="25" class="mr-2" />
                                        </div>
                                        <div class=" col-10 px-0">
                                            <div class="kt-font-bold">
                                                <h6 class="kt-font-bold m-0">
                                                    {{ "TimesheetApprovals" | localize }}<span class="text-danger  ml-1">*</span>
                                                </h6>
                                            </div>
                                            <div class="kt-font-md kt-padding-t-1 forecolor font-400">
                                                {{
 ""
                                                            | localize
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <form #timesheetForm="ngForm" id="timesheetForm" autocomplete="off">
                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                     data-parent="#accordionSettings">

                                    <div class="card-body Collapsed-panel-color"
                                         *ngIf="isCheckTimeSheetSettings">
                                        <div class="ml-3 p-3">
                                            <div class="font-weight-bolder">
                                                <label>
                                                    {{ "TimesheetSubmissionFrequency" | localize }} <span class="text-danger  ml-1">*</span>
                                                </label>

                                                <ng-select bindLabel="name" bindValue="id"
                                                           (change)="changeTSfreq()"
                                                           [(ngModel)]="projectTimesheet.submissionFrequency"
                                                           [closeOnSelect]="true" [multiple]="false"
                                                           placeholder="Select timesheet frequency"
                                                           [ngModelOptions]="{ standalone: true }"
                                                           [ngClass]="{'red-border' :projectTimesheet.submissionFrequency === undefined || projectTimesheet.submissionFrequency === null}">
                                                    <ng-option [value]="item.id"
                                                               *ngFor="let item of TimesheetFreqData; trackBy: trackById">
                                                        <div>
                                                            {{item.name}}
                                                        </div>
                                                    </ng-option>
                                                </ng-select>
                                            </div>
                                            <div *ngIf="projectTimesheet.submissionFrequency === undefined || projectTimesheet.submissionFrequency === null"
                                                 class="text-danger" style="font-size: 0.9rem !important;">
                                                <span>{{ "TimesheetSubmissionFrequencyismandatory" | localize }}</span>
                                            </div>

                                            <label class="font-weight-bolder mt-4">{{ "TimesheetApprovalProcess" | localize }}  </label>
                                            <div>{{ "SelectApprover" | localize }}</div>

                                            <div class="position-relative mt-2">
                                                <label class="level font-weight-bolder">
                                                    {{'Level' | localize}} 1 <span class="text-danger">*</span>
                                                </label>
                                                <approver-template [editApproverDetail]="approverDetailLevel1" [ProjectTeam]="filteredUsers" [levelValue]="1" [isRequired]="dataSubmitted" (approverDataSelection)="TimeSheetLevel1($event)" (dataChange)="projectTimesheetValid()"></approver-template>

                                            </div>

                                            <div *ngIf="TimesheetApproverLevelShow >= 1"
                                                 class="position-relative mt-5">
                                                <label class="level font-weight-bolder">
                                                    {{
 'Level' |
                                                                localize
                                                    }} 2 <span class="text-danger"></span>
                                                </label>
                                                <div class="float-right rigth-div cursor-pointer"
                                                     style="z-index: 6;">
                                                    <button type="button" (click)="removeLevel();removeLevelData(2)"
                                                            class="border-0 text-danger">
                                                        <i class="la la-times text-danger font-weight-bold"></i>
                                                    </button>
                                                </div>
                                                <approver-template [editApproverDetail]="approverDetailLevel2" [ProjectTeam]="timeSheetApprovarDropdown()" [levelValue]="2" [isRequired]="dataSubmitted" (approverDataSelection)="TimeSheetLevel2($event)"></approver-template>

                                            </div>

                                            <div *ngIf="TimesheetApproverLevelShow >= 2"
                                                 class="position-relative mt-5">
                                                <label class="level font-weight-bolder">
                                                    {{
 'Level' |
                                                                localize
                                                    }} 3 <span class="text-danger"></span>
                                                </label>
                                                <div class="float-right rigth-div cursor-pointer"
                                                     style="z-index: 6;">
                                                    <button type="button" (click)="removeLevel();;removeLevelData(3)"
                                                            class="border-0 text-danger">
                                                        <i class="la la-times text-danger font-weight-bold"></i>
                                                    </button>
                                                </div>
                                                <approver-template [editApproverDetail]="approverDetailLevel3" [ProjectTeam]="timeSheetApprovarDropdown()" [levelValue]="3" [isRequired]="dataSubmitted" (approverDataSelection)="TimeSheetLevel3($event)"></approver-template>

                                            </div>

                                            <div *ngIf="TimesheetApproverLevelShow >= 3"
                                                 class="position-relative mt-3">
                                                <label class="level font-weight-bolder">
                                                    {{
 'Level' |
                                                                localize
                                                    }} 4
                                                </label>
                                                <div class="float-right rigth-div cursor-pointer"
                                                     style="z-index: 6;">
                                                    <button type="button" (click)="removeLevel();removeLevelData(4)"
                                                            class="border-0 text-danger">
                                                        <i class="la la-times text-danger font-weight-bold"></i>
                                                    </button>
                                                </div>
                                                <approver-template [editApproverDetail]="approverDetailLevel4" [ProjectTeam]="filteredUsers" [levelValue]="4" [isRequired]="dataSubmitted" (approverDataSelection)="TimeSheetLevel4($event)"></approver-template>

                                            </div>

                                            <div *ngIf="TimesheetApproverLevelShow >= 4"
                                                 class="position-relative mt-3">
                                                <label class="level font-weight-bolder">
                                                    {{
 'Level' |
                                                                localize
                                                    }} 5
                                                </label>
                                                <div class="float-right rigth-div cursor-pointer"
                                                     style="z-index: 6;">
                                                    <button type="button" (click)="removeLevel();removeLevelData(5)"
                                                            class="border-0 text-danger">
                                                        <i class="la la-times text-danger font-weight-bold"></i>
                                                    </button>
                                                </div>
                                                <approver-template [editApproverDetail]="approverDetailLevel5" [ProjectTeam]="filteredUsers" [levelValue]="5" [isRequired]="dataSubmitted" (approverDataSelection)="TimeSheetLevel5($event)"></approver-template>

                                            </div>

                                            <div class="">
                                                <button type="button" class="btn btn-square btn-sm mt-3"
                                                        *ngIf="!isLevelCount5" (click)="addLevels()"
                                                        [disabled]="projectTimesheet.approverLevelOne==null"
                                                        style="color:#0078d4 ;">
                                                    <b>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                             height="16" fill="currentColor"
                                                             class="bi bi-plus-circle" viewBox="0 0 16 16">
                                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                        </svg> <small class="ml-2 font-12 font-weight-bolder">
                                                            {{
"Add
                                                                        Approver Level" | localize
                                                            }}
                                                        </small>
                                                    </b>
                                                </button>
                                            </div>

                                            <hr class="text-muted mb-4" />
                                            <div class="position-relative">
                                                <label class="level font-weight-bolder"> {{ 'Client Approver' | localize }} <span class="text-danger"></span></label>

                                                <div class="position-relative mt-2" clickOutside
                                                     (clickOutside)="closeClientApprovalDropdown('tableDiv-ClientApproval')">
                                                    <div class="btn-group w-100 border-radius-1">

                                                        <input name="filterTextClientApproval"
                                                               id="ClientApprovalDropdownBtn" type="button"
                                                               #ClientApproval="ngModel"
                                                               class="form-control m-0 btn border width-percent-100 text-left form-background border-right-0"
                                                               (click)="showtable('tableDiv-ClientApproval','scrollClientApproval')"
                                                               [placeholder]="l('Select Client Approver')"
                                                               [(ngModel)]="filterTextClientApproval"
                                                               type="text" (keyup)="getClientsContact()"
                                                               autocomplete="off">
                                                        <button id="SelectscrollClientApprovalDropdownButton"
                                                                type="button"
                                                                class="btn btn-sm dropdown-toggle dropdown-toggle-split form-left-background border border-left-0"
                                                                (click)="showtable('tableDiv-ClientApproval','scrollClientApproval')">
                                                            <span class="sr-only">
                                                                {{
'ToggleDropdown' |
                                                                            localize
                                                                }}
                                                            </span>
                                                        </button>
                                                    </div>

                                                    <div class="primeng-datatable-container showtable p-3 "
                                                         id="tableDiv-ClientApproval">

                                                        <div class="">
                                                            <div id="scrollClientApproval"
                                                                 *ngIf="clientsdata != null">
                                                                <p-table #dataTable
                                                                         [value]="clientContactDropdown"
                                                                         [paginator]="false" [lazy]="true"
                                                                         (click)="onClientApprovalDropDwnSelected()">
                                                                    <ng-template pTemplate="body"
                                                                                 let-clientContact>
                                                                        <tr [pSelectableRow]="clientContact"
                                                                            (click)="ClientAprroversSelection(clientContact)">

                                                                            <td class="align-top w-45px py-5">
                                                                                <div class="display-flex">
                                                                                    <div class="photo-background-team"
                                                                                         style="width: 40px; height: 40px;">
                                                                                        <img class=" w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                                                                             [src]="clientsdata.clientImageURL ? clientsdata.clientImageURL : 'assets/common/images/default-profile-picture1.svg'">
                                                                                    </div>
                                                                                </div>
                                                                            </td>

                                                                            <td class="align-top">
                                                                                <div>
                                                                                    <span class="font-12">
                                                                                        <b class="text-client-color">
                                                                                            {{ projectService.getFullname(clientContact.firstName, clientContact.lastName)}}

                                                                                        </b>
                                                                                    </span>
                                                                                    <small *ngIf="clientContact.isPrimary"
                                                                                           class="smallSize">
                                                                                        (Primary
                                                                                        Contact)
                                                                                    </small>
                                                                                </div>
                                                                                <div>
                                                                                    <small class="smallSize">{{clientContact.email}}</small>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="row mt-4 row" *ngIf="clientsdata != null">
                                                <div class="col-sm-12 col-md-12 col-lg-12" *ngFor="let clientContactApprover of clientContactApprovers; let i = index; trackBy: trackByIndex">
                                                    <div class="kt-portlet kt-portlet--height-fluid shadow-none border mouse-over">

                                                        <div class="p-3">
                                                            <div class="row">
                                                                <div class="col-sm-12 col-lg-12 col-md-12 d-flex align-items-center">
                                                                    <div class="col-2 photo-background-team">
                                                                        <img class=" kt-align-center h-40px w-40px"
                                                                             [src]="clientsdata.clientImageURL ? clientsdata.clientImageURL : 'assets/common/images/default-profile-picture1.svg'">
                                                                    </div>
                                                                    <div class=" col-9">
                                                                        <div class="row">

                                                                            <label class="photo-textsize mb-0 font-weight-bolder1">
                                                                                {{ projectService.getFullname(clientContactApprover.firstName, clientContactApprover.lastName)}}
                                                                            </label>
                                                                            <small *ngIf="clientContactApprover.isPrimary"
                                                                                   class="smallSize p-1">
                                                                                (Primary
                                                                                Contact)
                                                                            </small>
                                                                        </div>
                                                                        <div class="row mt-0 mb-1">
                                                                            <div class="mt-1 photo-email-text">
                                                                                {{clientContactApprover.email}}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-1 py-2  cursor-pointer align-items-end justify-content-center"
                                                                         (click)="ClientAprroversUnselection(clientContactApprover, i)">
                                                                        <img class="cursor-pointer"
                                                                             src="assets/common/images/projects/Delete_Icon.svg"
                                                                             width="15" />
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-12"
                                                     *ngIf="clientContactApprovers.length > 0">
                                                    <div class="mt-3 text-muted"> Approval window </div>
                                                    <div class="d-flex">
                                                        <div class="w-100">
                                                            <div class="">
                                                                <input type="number"
                                                                       (keypress)="onlyNumberKey($event)"
                                                                       class="form-control" required
                                                                       name="apprWinClient" min="0"
                                                                       #apprWin1="ngModel" placeholder="{{'Select Approval' | localize}}"
                                                                       [(ngModel)]="clientApprovalWindow"
                                                                       [ngClass]="{ 'red-border': projectForm.submitted && !clientApprovalWindow  }">
                                                            </div>
                                                            <div *ngIf="!clientApprovalWindow && clientContactApprovers?.length && projectForm.submitted"
                                                                 class="text-danger"
                                                                 style="font-size: 1rem !important;">
                                                                <span>Client approver window is required</span>
                                                            </div>
                                                        </div>
                                                        <label class="pr-4 pl-4 pt-2">in</label>
                                                        <div class="w-100">
                                                            <ng-select [items]="WindowEnum" bindValue="id" bindLabel="name" [(ngModel)]="clientApprovalWindowInEnum"
                                                                       placeholder="{{'SelectWindowType' | localize}}"
                                                                       [ngClass]="{ 'red-border': !clientApprovalWindowInEnum && projectForm.submitted } | localize">
                                                                <ng-template ng-option-tmp let-item="item">
                                                                    {{item.name | localize}}
                                                                </ng-template>
                                                            </ng-select>
                                                            <div id="error-message" class="text-danger " *ngIf="!clientApprovalWindowInEnum && projectForm.submitted">{{'WindowTypeismandatory' | localize}}</div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <!-- Commented For Future Use -->
                        <div class="card">
                            <div class="card-header" id="headingTwo">
                                <div id="collapse_icon" class="card-title collapsed" (click)="accordianOpen(1)">
                                    <div class="row ml-3 w-100">
                                        <div class="col-2">
                                            <img src="assets/common/images/integrations.svg" alt="logo" height="25" class="mr-2" />
                                        </div>
                                        <div class="col-10 px-0">
                                            <div class="">
                                                <h6 class="kt-font-bold m-0">{{ "Integrations" | localize }}</h6>
                                            </div>
                                            <div class="kt-padding-t-1 forecolor font-weight-lighter">
                                                {{ "For Unified Communication And Collaboration" | localize }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSettings">
                                <div class="card-body Collapsed-panel-color p-3">
                                    <div class="ml-3 mb-3 ">
                                        <label class="font-14"> {{ "Select Accounts" | localize }}</label>
                                        <div class="btn-group border-radius-1 projects w-100 mt-2"
                                             clickOutside
                                             (clickOutside)="CloseAssignedClientDropdown('tableDiv3')">
                                            <div class="btn-group width-percent-100 border-radius-1 mr-3 ng-untouched bg-white w-100">
                                                <button type="button"
                                                        class=" btn   "
                                                        (click)="showtable('tableDiv3', '')">
                                                    {{ "Selectplatformandtools" | localize }}
                                                </button>

                                            </div>
                                            <div class="showtable3 p-3 mr-3" id="tableDiv3" style="display: none">
                                                <div>
                                                    <h6 class="kt-font-bold mb-0 font-14">
                                                        {{ "Integrations" | localize }}
                                                        <button type="button"
                                                                class="close kt-font-danger kt-font-bold"
                                                                (click)="hideAccounts()">
                                                            <i class="up-arrow kt-font-lg"></i>
                                                        </button>
                                                    </h6>
                                                    <div *ngFor="let item of integration; let i = index; trackBy: trackById" class="overflow-auto">
                                                        <div class="d-flex cursor-pointer p-2 mb-1 list bg-hover-gray-200"
                                                             (click)="selectedIntegration(item);showSidePanel()">
                                                            <img [src]="item.icon" alt="logo" height="38" class="mr-2" />
                                                            <div class="ml-2">
                                                                <a class="cursor-pointer display-flex font-14 text-black">
                                                                    {{ item.name }}<span class="font-12 text-secondary"></span>
                                                                </a>
                                                                <span class="d-block text-tertiary font-12">{{ item.description }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngFor="let item of integrationSigleSelectedData; let i = index; trackBy: trackById">
                                            <div>
                                                <div>
                                                    <div class="position-absolute rigth-div mt-1">
                                                        <button type="button"
                                                                class="border-0 cursor-pointer bg-white text-danger"
                                                                (click)="deleteIntegrationSelection(i)">
                                                            <i class="la la-times text-danger font-weight-bold"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="d-flex cursor-pointer bg-white border rounded p-2 my-3 mr-3">
                                                    <img [src]="item.icon" alt="logo" height="38" class="mr-2" />
                                                    <div class="ml-2">
                                                        <a class="cursor-pointer display-flex font-12 font-weight-bold">
                                                            {{ item.name }}<span class="font-12 text-secondary"></span>
                                                        </a>
                                                        <span class="d-block text-tertiary font-12">{{ item.description }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingSix">
                                <div id="collapse_icon" class="card-title collapsed" (click)="projectDocsAccordionOpen = !projectDocsAccordionOpen">
                                    <div class="row ml-3 w-100">
                                        <div class="col-2">
                                            <img src="assets/common/images/projects/uploadProjectDocs.svg" alt="logo" height="25" class="mr-2" />
                                        </div>
                                        <div class="col-10 px-0">
                                            <div>
                                                <h6 class="kt-font-bold m-0">{{ "UploadProjectDocs" | localize }}</h6>
                                            </div>
                                            <div class="kt-padding-t-1 forecolor font-weight-lighter">
                                                {{ "UploadAndManageProjectDocuments" | localize }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="collapseSix" class="collapse" [class.show]="projectDocsAccordionOpen" aria-labelledby="headingSix">
                                <div class="card-body Collapsed-panel-color p-3">
                                    <app-project-docs-upload></app-project-docs-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p-drawer [(visible)]="isSidebarOpen" [blockScroll]="true" position="right" appendTo="body" styleClass="p-sidebar-md p-sidebar-bottom p-sidebar-zindex" id="edit-time-away-sidebar"
                   [style]="{'overflow': 'auto'}" [autoZIndex]="true">
            <div class="pb-3">
                <div class="h-100 d-flex flex-column" id="edit-task-component" [ngClass]="{'d-none': !isSidePanelOpen}">
                    <div class="bg-white h-100 px-4 pb-7 pt-3">
                        <div class="row">
                            <div class="col">
                                <div class="text-dark-6 font-weight-bolder mb-5 font-size-xl">
                                    DevOps Credentials
                                    <button type="button" class="close text-danger fs-2" (click)="closeSidePanel()" aria-label="Close">
                                        <i aria-hidden="true" class="ki ki-close"></i>
                                    </button>
                                </div>
                                <hr>
                                <div class="form-group">
                                    <label class="text-dark-50">Project Name<span class="required text-danger ml-1">*</span></label>
                                    <div class="rounded" [ngClass]="{ 'btn-border': devProjectNameInput.touched }">
                                        <input type="text" class="form-control"
                                               #devProjectNameInput="ngModel"
                                               [(ngModel)]="devProjectName" placeholder="Enter Project Name"
                                               (ngModelChange)="onDevProjectNameChange()"
                                               [ngClass]="{ 'is-invalid': devProjectNameInput.invalid && (devProjectNameInput.touched || devProjectNameInput.dirty) }" />
                                    </div>
                                    <div style="font-size: 0.9rem !important;">
                                        <span *ngIf="devProjectNameInput.touched && !isDevProjectNameValid" class="text-danger" id="error-message">
                                            {{ "Project name is mandatory" | localize }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="text-dark-50">Project URL<span class="required text-danger ml-1">*</span></label>
                                    <div class="rounded" [ngClass]="{ 'btn-border': projectURLInput.touched }">
                                        <input type="text" class="form-control"
                                               #projectURLInput="ngModel"
                                               [(ngModel)]="projectURL" placeholder="Enter Project URL"
                                               (ngModelChange)="onProjectURLChange()"
                                               [ngClass]="{ 'is-invalid': projectURLInput.invalid && (projectURLInput.touched || projectURLInput.dirty) }" />
                                    </div>
                                    <div style="font-size: 0.9rem !important;">
                                        <span *ngIf="projectURLInput.touched && !isProjectURLValid" class="text-danger">
                                            {{ "Project URL is mandatory" | localize }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="text-dark-50">Personal Access Token<span class="required text-danger ml-1">*</span></label>
                                    <div class="rounded" [ngClass]="{ 'btn-border': personalAccessTokenInput.touched }">
                                        <input type="text" class="form-control"
                                               #personalAccessTokenInput="ngModel"
                                               [(ngModel)]="personalAccessToken" placeholder="Enter Personal Access Token"
                                               (ngModelChange)="onPersonalAccessTokenChange()"
                                               [ngClass]="{ 'is-invalid': personalAccessTokenInput.invalid && (personalAccessTokenInput.touched || personalAccessTokenInput.dirty) }" />
                                    </div>
                                    <div style="font-size: 0.9rem !important;">
                                        <span *ngIf="personalAccessTokenInput.touched && !isPersonalAccessTokenValid" class="text-danger">
                                            {{ "Personal Access Token is mandatory" | localize }}
                                        </span>
                                    </div>
                                    <div class="d-flex justify-content-end align-items-center mt-4">
                                        <div class="d-flex justify-content-end align-items-center">
                                            <button class="btn btn-primary btn-sm rounded-0 font-size-base mr-5" [ngClass]="{ 'd-none': !isSidePanel }" type="button" (click)="closeSidePanel()">
                                                <i class="mx-0 la icon la-plus-circle text-white"></i>Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-primary position-absolute p-2 rounded-left" [ngClass]="{ 'd-none': !isSidePanel }"
                     style="left: -2.48rem; top: 0" (click)="closeSidePanel()">
                </div>
            </div>
        </p-drawer>
        <div class="col-12 footer">
            <div role="actions" id="projectCancel">
                <div class="text-right">
                    <button type="button" class="btn btn-square btn-outline-danger px-5 mr-1"
                            (click)="close()">
                        {{ "Cancel" | localize }}
                    </button>
                    <button type="submit" class="btn btn-square btn-primary px-8" form="projectForm"
                            [disabled]="saving">
                        {{ "Save" | localize }}
                    </button>
                </div>

            </div>
        </div>

    </div>
</div>

<project-image-upload #projectimgmodal (valueChange)="displayCounter($event)"></project-image-upload>
<app-modal-popup #appModalPopup message="Are you sure ?" submessage="Changes will not be saved"
                 (clickedYes)="navigateToProjects()" (clickedCancel)="navigationUrl = null"></app-modal-popup>
<app-modal-popup #appChangeRouteModalPopup message="Are you sure ?" submessage="Changes will not be saved"
                 (clickedYes)="changeRouteModalYes($event)" (clickedCancel)="changeRouteModalCancel()"></app-modal-popup>
